import type { TFunction } from "i18next";

export function getInvoicingMethodLabel(
  method: EasyTech.InvoicingMethod,
  t: TFunction
): string {
  return t(`admin:invoicingMethods.${method}`, method);
}
